import axios from 'axios';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  axios: axios.create(),
  types: [],
  riskCategories: {
    transports: [],
    venues: [],
    accommodations: [],
    foods: [],
    activities: []
  },
  id: '0'
};

const store = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};

export default store;
